import React from 'react';
import { useEffectOnce } from 'react-use';
import Form from '../../../CommonComponents/Form';
import { Input } from '../../../CommonComponents/OPL/Input/Input';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';
import withForm from './withForm';
import { PRINCIPAL_ID } from '../../../ProfileOPL/OtherAssets/forms/DeferredCompensation/DeferredCompensationForm.meta';

const DeferredCompensationForm = ({ account, onUpdate, isEditable }) => {
  useEffectOnce(() => {
    onUpdate({ Owner: PRINCIPAL_ID });
  });

  return (
    <Form>
      <Form.Control>
        <InputNumberMask
          label="Value"
          leftIcon="fa fa-dollar-sign"
          allowNegative={false}
          disabled={!isEditable}
          value={account.Value}
          onChange={({ target: { value } }) => onUpdate({ Value: value })}
        />
      </Form.Control>
      <Form.Control>
        <Input
          label="Description"
          disabled={!isEditable}
          value={account.Name}
          onChange={({ target: { value } }) => onUpdate({ Name: value })}
        />
      </Form.Control>
    </Form>
  );
};

export default withForm(DeferredCompensationForm);
